<template>
  <div @click="handleClick(label)">
    <label
      :for="cbId"
      class="form-button-label btn btn-primary"
      :class="[selected ? 'btn-fill' : 'btn-outline-primary']"
    >
      <slot></slot>
    </label>
  </div>
</template>
<script>
export default {
  name: "base-button-label",
  props: {
    label: [String, Number],
    disabled: [Boolean, String],
    value: [String, Boolean]
  },
  data() {
    return {
      cbId: ""
    };
  },
  computed: {
    selected() {
      const regex = /^[0-9]{2}[\/][0-9]{2}[\/][0-9]{4}$/g;
      const isDate = regex.test(this.value);
      if (isDate && this.label === 'customDate') {
        return true
      } else {
        return this.value === this.label ? true : false;
      }
    },
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  created() {
    this.cbId = Math.random()
      .toString(16)
      .slice(2);
  },
  methods: {
    handleClick() {
      this.$emit("clicked", this.label);
    }
  }
};
</script>
<style>
.form-button-label {
  border-radius: 5px;
  padding: 5px !important;
  border: 1px solid #000;
  color: white;
  text-transform: none !important;
}
</style>